import React from 'react';

function SearchHistory({ history, onSelectHistory, onClearHistory }) {
  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (history.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-xl shadow-lg p-8 mb-8 mt-8">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-900">
          Search History
        </h2>
        <button
          onClick={onClearHistory}
          className="text-sm px-3 py-1 bg-red-100 hover:bg-red-200 text-red-700 rounded transition-colors"
        >
          Clear History
        </button>
      </div>

      <div className="space-y-3">
        {history.slice(0, 10).map((item, index) => (
          <div
            key={index}
            onClick={() => onSelectHistory(item)}
            className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
          >
            <div className="flex justify-between items-start mb-2">
              <div className="flex-1">
                <div className="flex flex-wrap gap-2 mb-2">
                  {item.concepts.map((concept, conceptIndex) => (
                    <span
                      key={conceptIndex}
                      className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-sm"
                    >
                      {concept}
                    </span>
                  ))}
                </div>
                
                {item.context && (
                  <p className="text-sm text-gray-600 mb-1">
                    Context: {item.context}
                  </p>
                )}
                
                {item.tones && item.tones.length > 0 && (
                  <div className="flex flex-wrap gap-1 mb-1">
                    <span className="text-xs text-gray-500">Tones:</span>
                    {item.tones.map((tone, toneIndex) => (
                      <span
                        key={toneIndex}
                        className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded"
                      >
                        {tone}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              
              <span className="text-xs text-gray-500 whitespace-nowrap ml-4">
                {formatDate(item.timestamp)}
              </span>
            </div>
            
            <div className="text-xs text-gray-500">
              {item.results ? `${item.results.groups.length} result groups` : 'No results'}
            </div>
          </div>
        ))}
        
        {history.length > 10 && (
          <div className="text-center text-sm text-gray-500 pt-2">
            Showing 10 of {history.length} searches
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchHistory;
